module.exports = __webpack_public_path__ + "img/dotted-line-lg.8a682864.svg";